import { IReactNodeViewContext } from 'common/Prose/nodeViews/ReactNodeView/ReactNodeViewContext'
import { mentionsConversionOptions } from 'common/Prose/utils/mentionsConversionOptions'
import { MentionSubject, SmartLinkAttributes } from 'common/Prose/utils/smartLinks/types'
import HandbookIcon from 'components/Handbook2_0/HandbookIcon'
import { MentionsFormatBar } from 'components/MentionsFormatBar/MentionsFormatBar'
import { useHandbook } from 'hooks/queries/handbooks/useHandbook'
import { useEffect, useMemo, useState } from 'react'
import { type EditableSmartLinkChildProps } from './EditableSmartLink'

export const HandbookSmartLink = (props: EditableSmartLinkChildProps) => {
  const {
    sanitizedHTML,
    nodeViewContext,
    dataProps,
    handleLinkClick,
    showMentionFormatBar,
    setShowMentionFormatBar,
    parentRef,
  } = props
  const { node, getPos, view } = nodeViewContext as IReactNodeViewContext
  const attrs = node.attrs
  const { key, type, url, title } = attrs as SmartLinkAttributes

  const [mentionSubject, setMentionSubject] = useState<MentionSubject | null>({
    title: title,
    avatar: { emoji: <HandbookIcon /> },
  })

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { data: handbookData } = useHandbook(key!, { staleTime: 10 * 1000 })

  useEffect(() => {
    if (type !== 'Handbook' || !handbookData) return
    const { name, emoji } = handbookData.handbook

    setMentionSubject({
      avatar: { emoji: emoji ?? <HandbookIcon handbook={handbookData.handbook} /> },
      title: name,
    })
  }, [type, handbookData])

  const displayTitle = useMemo(() => mentionSubject?.title || title, [mentionSubject?.title, title])

  return (
    <>
      {showMentionFormatBar && (
        <MentionsFormatBar
          view={view}
          close={() => setShowMentionFormatBar(false)}
          getPos={getPos}
          mentionSubject={mentionSubject}
          smartLinkUuid={dataProps['data-uuid']}
          subtitle={''}
          link={url}
          node={node}
          onLinkClick={handleLinkClick}
          conversionOptions={mentionsConversionOptions(node, getPos(), view, displayTitle)}
          parentRef={parentRef}
          forceFormatBarVisible={setShowMentionFormatBar}
          linkPosition={{ from: getPos(), to: getPos() + node.nodeSize }}
        />
      )}
      <a
        data-test-id="smart-link-editable"
        {...dataProps}
        href={url}
        onClick={handleLinkClick}
        tabIndex={-1}
        rel="noreferrer"
        dangerouslySetInnerHTML={sanitizedHTML}
      ></a>
    </>
  )
}
